<script setup lang="ts">
import collapsibleTableContainer from '@/core/containers/collapsible-table-container.vue';
import useCoreUtils from '@/core/composable/use-core-utils';
import { IColumn, TableBasedContainerOptions } from '@/stores/core/models';
import { Permission, Profile } from '@/stores/profiles/models';
import { useProfilesStore } from '@/stores/profiles/store';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { ROUTE_PROFILES_DETAILS } from '@/router/profiles/routes';
import ProfileCreateDialog from '@/dialogs/profiles/profile-create-dialog.vue';
import { AppPermissions } from '@/shared/permissions';
import usePermissionChecker from '@/core/composable/use-permission-checker';
type T = Profile;
const store = useProfilesStore();
const { propertyOf } = useCoreUtils();
const { profiles } = storeToRefs(store);
const {hasPermission} = usePermissionChecker();
const columns = [
   {
    field: propertyOf<T>('profileName'),
    header: 'core.name',
    sortable: true,
    detailsRoute: ROUTE_PROFILES_DETAILS,
    detailsRouteParamField: propertyOf<T>('id'),
  },
  { field: propertyOf<T>('description'), header: 'indexes.description' },

  {
    field: propertyOf<T>('permissions'),
    header: 'profiles.permissions',
    useCustomTemplate2: true,
  },
  { field: propertyOf<T>('createdAt'), header: 'core.createdAt', formatAsDateTime: true, sortable: true },
] as IColumn[];

const options = computed(() => {
  const opts = new TableBasedContainerOptions(columns, profiles.value, 'profile');

  const canWrite = hasPermission(AppPermissions.ProfilesWrite);
  const canDelete = hasPermission(AppPermissions.ProfilesDelete);

  opts.toolbarOptions.showAddNew = true;
  opts.toolbarOptions.disableAddNew = !canWrite;

  opts.toolbarOptions.showDelete = true;
  opts.toolbarOptions.canDelete = canDelete;
  opts.toolbarOptions.isDeleteEnabled = false;

  return opts;
});

const onNewDialog = () => {
  store.isCreateProfileDialogVisible = true;
};
</script>

<template>
  <collapsible-table-container :options="options" @new="onNewDialog">
    <template #custom2="{ row }">
      {{ row.permissions.length ? row.permissions[0].name : '-' }}
      <span
        v-if="row.permissions.length > 1"
        v-tooltip.bottom="{
          value: row.permissions.map((x: Permission) => x.name).join('\n'),
          class: 'permissions-tooltip',
          autoHide:false,
          pt: {
            text: {
              style: 'max-height: 180px; overflow-y: auto; white-space: pre-line; min-width: 220px;background-color:#050A17;color:white;',
            },
          },
        }"
      >
        (+{{ row.permissions.length - 1 }})
      </span>
    </template>
  </collapsible-table-container>

  <profile-create-dialog />
</template>
